import { useContext } from "react";
import formatDateString from "../../../Util/functions/FormatDateString";
import formatTimeString from "../../../Util/functions/FormatTimeString";
import { FadeInOut } from "../../../Util/animations/Animations_v2";
import { motion } from "framer-motion";
import { AppContext } from "../../../Util/contexts/AppContext";
import { getClientTimezoneName } from "../../../Util/functions/TimeZone";
const GradingHeader = ({
  gradingData,
  shouldShowPreviousCompletionsButton,
}) => {
  const { userData, handleViewPreviousExamCompletions } =
    useContext(AppContext);

  return (
    <motion.div
      className="newGradingCaseTitleContainer"
      {...FadeInOut(userData.AnimationDisabled, 0.2)}
      key="newGradingCaseTitleContainer"
    >
      <div className="newGradingCaseNumberContainer">
        <h1 className="newGradingCaseNumber">{gradingData.examId}</h1>
      </div>
      <div className="newGradingCaseTitleWrapper">
        <h2 className="newGradingCaseTitle">{gradingData.ExamTitle}</h2>
        <h3 className="newGradingCaseCompletionDate">
          Completed:{" "}
          {formatDateString(
            gradingData.DateCompleted,
            userData.TimeZoneOverride
              ? getClientTimezoneName()
              : userData.TimeZone
          )}
          ,{" "}
          {formatTimeString(
            gradingData.DateCompleted,
            userData.TimeZoneOverride
              ? getClientTimezoneName()
              : userData.TimeZone
          )}
        </h3>
      </div>
      {shouldShowPreviousCompletionsButton && (
        <button
          className="newGradingViewPreviousButton tertiaryButton"
          onClick={() => handleViewPreviousExamCompletions(gradingData.examId)}
        >
          View Previous Completions
        </button>
      )}
    </motion.div>
  );
};

export default GradingHeader;
